import api from '../utils/api';

// Fetch all users
export const getAllUsers = async (headers) => {
  try {
    const response = await api.get('/api/users', headers);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error('Error fetching all users:', error.response.data);
    } else if (error.request) {
      console.error('Error fetching all users: No response received', error.request);
    } else {
      console.error('Error fetching all users:', error.message);
    }
    throw error;
  }
};
